"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var userdefined_1 = require("../../../interfaces/userdefined");
var mobx_react_1 = require("mobx-react");
var buttons_1 = require("../../buttons");
var userDefinedField_1 = require("../../userDefinedField");
var queryStringParser_1 = require("../queryStringParser");
var App_1 = require("../../../App");
var config_1 = require("../../../config");
var settings_1 = require("../settings");
var orderingList_1 = require("../orderingList");
var filters_1 = require("../filters");
var generic_1 = require("../../generic");
var savedViews_1 = require("../../savedViews");
var CausalityListToolbar = (function (_super) {
    __extends(CausalityListToolbar, _super);
    function CausalityListToolbar(props) {
        var _this = _super.call(this, props) || this;
        _this.savedViewsRef = React.createRef();
        _this.getStateFragment = function () {
            return _this.props.is_cause ?
                App_1.store.causalitylist.causes :
                App_1.store.causalitylist.effects;
        };
        _this.onOrder = function () {
            _this.getStateFragment().fetchData(window.location.search);
        };
        _this.onSaveSettings = function (values) {
            _this.getStateFragment().settings.update(values).then(function () {
                var _a;
                _this.getStateFragment().fetchData(window.location.search);
                (_a = _this.savedViewsRef.current) === null || _a === void 0 ? void 0 : _a.refresh();
            });
        };
        _this.countFilters = function () {
            return _this.state.qs.get_key_count_for(['q', 'id_status', 'id_owner', 't', 'confidential', 'eval',
                'reviewed_by', 'reviewed_before', 'reviewed_after'
            ].concat(_this.props.is_cause ? ['cause_search', 'unattached_causes']
                : ['effect_search', 'unattached_effects'])) + _this.state.qs.get_udf_key_count();
        };
        _this.applyHandler = function (event) {
            var paramsString = _this.state.qs.toString();
            window.history.pushState(null, null, window.location.pathname + "?" + paramsString);
            _this.getStateFragment().fetchData("?" + paramsString);
            jQuery('#riskFilterCollapsible').removeClass('show');
        };
        _this.changeHandler = function (name, value) {
            var newState = {};
            if ((0, userdefined_1.isFieldType)(name)) {
                value = value.map(function (udf_value) {
                    if (udf_value.field_type.type_id == userDefinedField_1.UDFTypeChoices.DATE &&
                        !udf_value.field_type.options && udf_value.value != null)
                        udf_value.value = udf_value.value.format(config_1.ISO_DATE_FORMAT);
                    return udf_value;
                });
                var udf_type_1 = name;
                newState["udf_values"] = (_this.state.udf_values
                    .filter(function (udf_value) { return udf_value.field_type.id != udf_type_1.id; })
                    .concat(value));
            }
            else
                newState[name] = value;
            var new_qs = _this.state.qs.clone();
            new_qs.reset_from_state(__assign(__assign({}, _this.state), newState));
            newState['qs'] = new_qs;
            _this.setState(newState);
        };
        _this.handleKeypress = function (e) {
            console.log(e.key);
            if (e.key === 'Enter') {
                $('#apply_button').click();
            }
        };
        _this.onApplyView = function (view) {
            var sep = view.queryString.includes("?") ? "&" : "?";
            var qs = view.queryString + sep + "savedview=" + view.id;
            window.history.pushState(null, null, window.location.pathname + qs);
            _this.getStateFragment().settings.fetchData(qs);
            _this.getStateFragment().fetchData(qs);
        };
        var qs = new queryStringParser_1.QueryStringParser(window.location.search);
        _this.state = {
            qs: qs,
            q: qs.get("q") || "",
            id_status: qs.getAll("id_status"),
            id_owner: qs.getAll("id_owner"),
            t: qs.getAll("t"),
            confidential: qs.getAll("confidential"),
            eval: qs.getAll("eval"),
            reviewed_by: qs.getAll("reviewed_by"),
            reviewed_before: qs.get("reviewed_before"),
            reviewed_after: qs.get("reviewed_after"),
            udf_values: qs.get_udf_fields(),
            cause_search: qs.get("cause_search") || "",
            unattached_causes: !!qs.get("unattached_causes"),
            effect_search: qs.get("effect_search") || "",
            unattached_effects: !!qs.get("unattached_effects"),
        };
        return _this;
    }
    CausalityListToolbar.prototype.render = function () {
        var _this = this;
        var context = App_1.store.context.get();
        var filter_counter = this.countFilters();
        var props = this.props;
        return (React.createElement("div", { id: "listAccordion" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    props.is_cause ?
                        get_term("Number of causes in current filtering")
                        :
                            get_term("Number of effects in current filtering"),
                    ": ",
                    this.props.rows_counter)),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("div", { className: "btn-toolbar mb-3", role: "toolbar", "aria-label": "Toolbar with button groups" },
                        React.createElement("div", { className: "col-6" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "input-group" },
                                    React.createElement("input", { name: "q", type: "text", defaultValue: this.state.qs.get('q'), className: "form-control", placeholder: gettext("Search"), onChange: function (e) { return _this.changeHandler(e.currentTarget.name, e.currentTarget.value); }, onKeyPress: this.handleKeypress }),
                                    React.createElement("div", { className: "input-group-append" },
                                        React.createElement("button", { className: "btn btn-primary btn-block", id: "apply_button", type: "button", onClick: this.applyHandler },
                                            React.createElement("span", { className: "fa fa-search" })))),
                                React.createElement("div", { className: "btn-group", role: "group", "aria-label": "Filter, List Settings and Ordering group" },
                                    React.createElement("button", { type: "button", className: "btn btn-link", id: "filter", "data-toggle": "collapse", "data-target": "#riskFilterCollapsible", "aria-expanded": "false", "aria-controls": "riskFilterCollapsible" },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.filter }),
                                        " ",
                                        gettext("Filters"),
                                        " ",
                                        filter_counter > 0 && (React.createElement("span", { className: "badge badge-pill badge-primary" }, filter_counter))),
                                    React.createElement("button", { type: "button", className: "btn btn-link", id: "setting", "data-toggle": "collapse", "data-target": "#riskSettingsCollapsible", "aria-expanded": "false", "aria-controls": "riskSettingsCollapsible" },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.cog }),
                                        " ",
                                        gettext("List settings")),
                                    React.createElement("button", { type: "button", className: "btn btn-link", id: "ordering", "data-toggle": "collapse", "data-target": "#riskOrderingCollapsible", "aria-expanded": "false", "aria-controls": "riskOrderingCollapsible" },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.sorting }),
                                        " ",
                                        gettext("Ordering"))))),
                        React.createElement("div", { className: "col-6" },
                            React.createElement("div", { className: "row justify-content-end" },
                                React.createElement("div", { className: "btn-group d-none d-lg-inline-flex", role: "group", "aria-label": "Actions group" },
                                    React.createElement(buttons_1.ActionButton, { onClick: function () { return (props.is_cause ? App_1.store.causeDialog : App_1.store.effectDialog).openDialog(null, props.is_cause); } },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }),
                                        "  ",
                                        props.is_cause ? get_term("New cause") : get_term("New effect")),
                                    React.createElement(buttons_1.ActionButton, { onClick: function () {
                                            $('#EditableList__BulkButtonId').click();
                                        } },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.edit }),
                                        props.is_cause ? get_term("Edit causes") : get_term("Edit effects")),
                                    this.props.has_business_model &&
                                        React.createElement(buttons_1.ActionButton, { onClick: function () { return _this.props.clickExportHandler.bind(_this)(); }, style: buttons_1.ButtonStyles.ACTION },
                                            React.createElement(generic_1.Icon, { name: generic_1.Icons.file_excel }),
                                            " ",
                                            gettext("Export"))),
                                React.createElement("div", { className: "btn-group d-lg-none", role: "group" },
                                    React.createElement(buttons_1.ActionButton, { onClick: function () { return (props.is_cause ? App_1.store.causeDialog : App_1.store.effectDialog).openDialog(null, props.is_cause); } },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }),
                                        "  ",
                                        props.is_cause ? get_term("New cause") : get_term("New effect")),
                                    React.createElement(buttons_1.ActionButton, { className: "dropdown-item", onClick: function () {
                                            $('#EditableList__BulkButtonId').click();
                                        } },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.edit }),
                                        props.is_cause ? get_term("Edit causes") : get_term("Edit effects")),
                                    React.createElement("button", { type: "button", className: "btn btn-link dropdown-toggle dropdown-toggle-split", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
                                        React.createElement("span", { className: "sr-only" }, "Toggle Dropdown")),
                                    React.createElement("div", { className: "dropdown-menu" }, this.props.has_business_model &&
                                        React.createElement(buttons_1.ActionButton, { onClick: function () { return _this.props.clickExportHandler.bind(_this)(); }, style: buttons_1.ButtonStyles.ACTION },
                                            React.createElement(generic_1.Icon, { name: generic_1.Icons.file_excel }),
                                            " ",
                                            gettext("Export")))),
                                React.createElement("div", null,
                                    React.createElement(savedViews_1.SavedViewsDropdown, { ref: this.savedViewsRef, projectId: String(context.project), listType: this.props.is_cause ? "cause" : "effect", onApplyView: this.onApplyView }))))))),
            React.createElement("div", { className: "row toolbarCollapsible" },
                React.createElement("div", { className: "col-sm-12 col-md-4 collapse", id: "riskFilterCollapsible" },
                    React.createElement(filters_1.CausalityFilter, { is_cause: this.props.is_cause, filter: this.props.is_cause ?
                            App_1.store.causalitylist.causes.filter.data :
                            App_1.store.causalitylist.effects.filter.data, qs: this.state.qs, onChangeHandler: this.changeHandler }),
                    React.createElement("div", { className: "mb-3" },
                        React.createElement("button", { className: "btn btn-primary btn-block", type: "button", onClick: this.applyHandler }, gettext("Apply")))),
                React.createElement("div", { className: "col-sm-12 col-md-4 collapse", id: "riskSettingsCollapsible" },
                    React.createElement(settings_1.default, { settings: this.getStateFragment().settings.data, save: this.onSaveSettings })),
                React.createElement("div", { className: "col-sm-12 col-md-4 collapse", id: "riskOrderingCollapsible" },
                    React.createElement(orderingList_1.default, { ordering: this.getStateFragment().data.ordering, onOrder: this.onOrder })))));
    };
    CausalityListToolbar = __decorate([
        mobx_react_1.observer
    ], CausalityListToolbar);
    return CausalityListToolbar;
}(React.Component));
exports.default = CausalityListToolbar;
